import * as React from "react";
import { Layout } from "../../layout";
import { Routes, Route } from "react-router-dom";
import { HelmReleasesList } from "./list";
import { HelmReleaseDetail } from "./detail";
import { HelmLegacyReleaseDetail } from "./legacyDetail";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";

const HelmReleasesRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<HelmReleasesList />} />
        <Route path={`legacy/:release/*`} element={<HelmLegacyReleaseDetail />} />
        <Route path={`:release/*`} element={<HelmReleaseDetail />} />
      </Routes>
    </Layout>
  );
};

export default HelmReleasesRoute;
